import * as yup from 'yup';
import { FORM_MESSAGE } from '../../fastForm/data/constants';

export const catchUpSchema = () =>
	yup.object().shape({
		catchUp: yup.object().shape({
			amount: yup
				.string()
				.required(FORM_MESSAGE.required)
				.test('number', FORM_MESSAGE.number, (value) => {
					if (value === undefined || value === null) {
						return true;
					}
					return !isNaN(Number(value));
				})
				.test('isPositive', FORM_MESSAGE.postiveNum, (value) => {
					return parseFloat(value) > 0;
				}),
			dueDate: yup.string().required(FORM_MESSAGE.required),
			policyLocator: yup.string(),
			policyholderLocator: yup.string(),
		}),
	});
